// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Success_wrapper__BGDQG"};